var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-abstract-unit"},[_c('p',{class:{ 'data-abstract-unit-key-h': _vm.isHighLight }},[_vm._v(_vm._s(_vm.title)+"：")]),_c('input',{staticClass:"data-abstract-unit-value",domProps:{"value":_vm.ahiValue}})])
}
var staticRenderFns = []

export { render, staticRenderFns }